<template>
	<el-switch
		class="inputSigarusSwitch"
		v-click-outside="outside"
		v-model="model"
		v-bind="{...$attrs, ...$props}"
		@focus="focusito()"
		ref="input">
	</el-switch>
</template>

<script>
	export default {
		name: 'InputSigarusSwitch',
		props: {
			value: {
				default: ''
			}
		},
		computed: {

			model: {

				get () {
					return this.value === "1"
				},

				set (val) {
					this.$emit('input', val ? "1" : "0")
					this.$emit('save')
				}

			}
		},
		methods: {
			$render (val) {

				let disabled = `<div role="switch" class="renderSwitch el-switch el-tooltip">
					<span class="el-switch__core" style="width: 40px"></span>
				</div>`;

				let active = `<div role="switch" class="renderSwitch el-switch el-tooltip is-checked">
					<span class="el-switch__core" style="width: 40px"></span>
				</div>`;

				return val == 1 ? active : disabled
			},

			// focus () { setTimeout(() => this.$emit('focus'), 100) },
			
			focus () { setTimeout(() => this.$refs.input.focus(), 200) },

			outside() { this.$emit('blur') },

			focusito() { console.log('focus')}
		}
	}
</script>

<style lang="scss">
.inputSigarusSwitch {
	padding: 0.4rem 0.50rem;
    flex-grow: 0!important;
}

.renderSwitch {
	
	&.is-checked {
		> .el-switch__core {
			border-color: #d63031;
    		background-color: #d63031;
		}
	}
}
</style>
